// « Régler » / « Annuler » of an open « en attente » (§8.8k) — the Journal's
// job, now on the row that carries it: a Départs row, or a line of the day's
// other payments on Arrivées. « Régler » opens the form on it (the real
// payment is linked to the attente); « Annuler » closes it without money
// moving. Hidden on paper and from a read-only desk.

import type { ReceptionPaymentId } from '@lemontaigu/pms-core';
import { fmtAmount, fmtEuros } from './logic.js';
import type { SuspenseToSettle } from './departureSheet.js';

export interface SuspenseActionsProps {
  items: SuspenseToSettle[];
  canBill: boolean;
  onSettle?: (s: SuspenseToSettle) => void;
  onCancel?: (id: ReceptionPaymentId) => void;
}

export function SuspenseActions({ items, canBill, onSettle, onCancel }: SuspenseActionsProps) {
  if (!canBill || items.length === 0 || (!onSettle && !onCancel)) return null;
  return (
    <div className="pms-suspense-actions pms-no-print">
      {items.map((s) => (
        <span key={s.id} className="pms-suspense">
          {items.length > 1 && <span className="pms-sub">{fmtAmount(s.cents)} </span>}
          {onSettle && (
            <button
              type="button"
              className="pms-mini"
              onClick={() => onSettle(s)}
              aria-label={`Régler l’attente de ${fmtEuros(s.cents)}`}
            >
              Régler
            </button>
          )}
          {onCancel && (
            <button
              type="button"
              className="pms-mini"
              onClick={() => onCancel(s.id)}
              aria-label={`Annuler l’attente de ${fmtEuros(s.cents)}`}
            >
              Annuler
            </button>
          )}
        </span>
      ))}
    </div>
  );
}
